var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonRadius',{class:{ 'is-loading': _vm.isProcessing },attrs:{"priority":"low-white","disabled":_vm.isProcessing,"iconLeft":"download"},on:{"click":_vm.getCsv}},[_c('span',[_vm._v("CSVダウンロード")])])
}
var staticRenderFns = []

export { render, staticRenderFns }